const CYRILLIC: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  ђ: 'đ',
  е: 'e',
  ж: 'ž',
  з: 'z',
  и: 'i',
  ј: 'j',
  к: 'k',
  л: 'l',
  љ: 'lj',
  м: 'm',
  н: 'n',
  њ: 'nj',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  ћ: 'ć',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'č',
  џ: 'dž',
  ш: 'š',
};

/** Serbian Cyrillic in Serbian Latin, lower case: "Ђорђевић" → "đorđević". */
export const serbianLatin = (text: string): string =>
  Array.from(text.toLowerCase(), (ch) => CYRILLIC[ch] ?? ch).join('');

const collator = new Intl.Collator('sr-Latn', { sensitivity: 'base', numeric: true });

/** Serbian alphabetical order (c, č, ć; d, dž, đ), with Cyrillic among the Latin, not after it. */
export const compareSerbian = (a: string, b: string): number =>
  collator.compare(serbianLatin(a), serbianLatin(b));
